import { useEffect, useState } from "react";
import AdminService from "../../../../service/AdminService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import localeText from "../../../../locale";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { FilterMatchMode } from "primereact/api";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { formatDate } from "../../../../utilities/formatDate";
import { Calendar } from "primereact/calendar";

const ListUsers = (props) => {
  const adminService = new AdminService();

  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [blockingUnblockingVisible, setBlockingUnblockingVisible] = useState(false);
  const [username, setUsername] = useState("");
  const [blocking, setBlocking] = useState(true);
  const [calendarDate, setCalendarDate] = useState("");

  const toast = useRef(false);

  useEffect(() => {
    let cancel = false;

    fetchUsers(cancel);

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatCancelledUsers = (users) => {
    users.forEach((user) => {
      if (user.cancelled) {
        user.username = "Cancelled";
        user.firstname = "";
        user.surname = "";
        user.phonenumber = "";
        user.email = "";
        user.referall = "";
      }
    });
  };

  async function fetchUsers(cancel) {
    try {
      setLoading(true);

      if (props.plan === "areamanager") {
        const resAreas = await adminService.getAreaManagers(
          localStorage.getItem("__extraconomy_token")
        );
        if (cancel) return;

        formatCancelledUsers(resAreas.result.userListJSONs);

        if (resAreas.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resAreas.messageCode).message,
            life: 6000,
          });
          setLoading(false);
        } else {
          setUsers(resAreas.result.userListJSONs);
          setFilteredUsers(resAreas.result.userListJSONs);
          setLoading(false);
        }
      }

      if (props.plan === "businesspartner") {
        const resBusiness = await adminService.getBusinessPartners(
          localStorage.getItem("__extraconomy_token")
        );

        formatCancelledUsers(resBusiness.result.userListJSONs);

        if (resBusiness.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resBusiness.messageCode).message,
            life: 6000,
          });
          setLoading(false);
        } else {
          setUsers(resBusiness.result.userListJSONs);
          setFilteredUsers(resBusiness.result.userListJSONs);
          setLoading(false);
        }
      }

      if (props.plan === "specialcustomer") {
        const resSpecial = await adminService.getSpecialCustomers(
          localStorage.getItem("__extraconomy_token")
        );

        formatCancelledUsers(resSpecial.result.userListJSONs);

        if (resSpecial.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resSpecial.messageCode).message,
            life: 6000,
          });
          setLoading(false);
        } else {
          setUsers(resSpecial.result.userListJSONs);
          setFilteredUsers(resSpecial.result.userListJSONs);
          setLoading(false);
        }
      }

      if (props.plan === "salepromoter") {
        const resPromoters = await adminService.getSalePromoter(
          localStorage.getItem("__extraconomy_token")
        );

        formatCancelledUsers(resPromoters.result.userListJSONs);

        if (resPromoters.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resPromoters.messageCode).message,
            life: 6000,
          });
          setLoading(false);
        } else {
          setUsers(resPromoters.result.userListJSONs);
          setFilteredUsers(resPromoters.result.userListJSONs);
          setLoading(false);
        }
      }

      if (props.plan === "sellers") {
        const resSellers = await adminService.getSellers(
          localStorage.getItem("__extraconomy_token")
        );

        formatCancelledUsers(resSellers.result.userListJSONs);

        if (resSellers.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resSellers.messageCode).message,
            life: 6000,
          });
          setLoading(false);
        } else {
          setUsers(resSellers.result.userListJSONs);
          setFilteredUsers(resSellers.result.userListJSONs);
          setLoading(false);
        }
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      console.log(e);
      setLoading(false);
    }
  }

  const filters2 = {
    username: { value: null, matchMode: FilterMatchMode.CONTAINS },
    firstname: { value: null, matchMode: FilterMatchMode.CONTAINS },
    email: { value: null, matchMode: FilterMatchMode.CONTAINS },
    phonenumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
    referall: { value: null, matchMode: FilterMatchMode.CONTAINS },
    dateCreation: { value: null, matchMode: FilterMatchMode.DATE_IS },
  };

  async function blockOrUnblockUser(username, block) {
    try {
      setLoading(true);

      const res = await adminService.postBlockOrUnblockUser(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username"),
        username,
        block ? true : false
      );

      if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        if (res.messageCode === 500000) console.log(res);
        setLoading(false);
      } else {
        toast.current.show({
          severity: block ? "info" : "success",
          summary: localeText(block ? "info" : "success"),
          detail: localeText(block ? "userBlockedSuccessfully" : "userUnblockedSuccessfully"),
          life: 6000,
        });
        fetchUsers(false);
        setLoading(false);
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      setLoading(false);
      console.log(e);
    }
  }

  const filterByDate = (date) => {
    if (date) {
      const filteredData = filteredUsers.filter(
        (obj) => formatDate(obj?.dateCreation) === formatDate(date)
      );
      setFilteredUsers([...filteredData]);
    } else {
      setFilteredUsers(users);
    }
  };

  const dateFilterTemplate = (options) => {
    return (
      <div className="flex justify-content-center align-items-center">
        <Calendar
          value={calendarDate}
          onChange={(e) => {
            setCalendarDate(e.value);
            filterByDate(new Date(e.value));
          }}
          dateFormat="dd/mm/yy"
          placeholder="Selecione uma data"
          showIcon
        />
        <Button
          icon="pi pi-times"
          size="small"
          className="p-button-danger p-button-rounded p-button-text"
          onClick={() => {
            setCalendarDate("");
            setFilteredUsers(users);
          }}
        />
      </div>
    );
  };

  return (
    <div className="card border-1 border-300 border-round">
      {props.plan === "areamanager" && <h3 className="my-4">Managers</h3>}
      {props.plan === "businesspartner" && <h3 className="my-4">Business Parners</h3>}
      {props.plan === "specialcustomer" && <h3 className="my-4">Customers</h3>}
      {props.plan === "salepromoter" && <h3 className="my-4">Promoters</h3>}
      <hr />

      <ConfirmDialog
        visible={blockingUnblockingVisible}
        onHide={() => setBlockingUnblockingVisible(false)}
        message={localeText(blocking ? "areYouSureBlockUser" : "areYouSureUnblockUser")}
        header={localeText("confirmYourAction")}
        icon="pi pi-exclamation-triangle"
        accept={() => blockOrUnblockUser(username, blocking)}
        reject={() => setBlockingUnblockingVisible(false)}
        acceptLabel={localeText("confirm")}
        rejectLabel={localeText("cancel")}
      />

      <Toast ref={toast} />
      <DataTable
        value={filteredUsers}
        paginator
        responsiveLayout="scroll"
        loading={loading}
        filters={filters2}
        filterDisplay="row"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={localeText("showingFirstToLast")}
        rows={10}
        rowsPerPageOptions={[10, 20, 50]}
      >
        <Column
          field="username"
          header={localeText("username")}
          filter
          filterPlaceholder={localeText("searchByUsername")}
          filters={filters2}
          filterDisplay="row"
          sortable
        />
        <Column
          field="email"
          header="Email"
          filter
          filterPlaceholder={localeText("searchByEmail")}
          filters={filters2}
          filterDisplay="row"
        />
        <Column
          field="firstname"
          filter
          filterPlaceholder={localeText("searchByUsername")}
          filters={filters2}
          filterDisplay="row"
          header={localeText("firstName")}
        />
        <Column field="surname" header={localeText("surname")} />
        <Column
          field="phonenumber"
          filter
          filterPlaceholder={localeText("searchByPhonenumber")}
          filters={filters2}
          filterDisplay="row"
          header={localeText("phoneNumber")}
        />
        <Column
          field="referall"
          filter
          filterPlaceholder={localeText("searchByUsername")}
          filters={filters2}
          filterDisplay="row"
          header={localeText("referralUsername")}
        />
        <Column
          header={localeText("adminBackofficeDateCreation")}
          field="dateCreation"
          filter
          dataType="date"
          filterElement={dateFilterTemplate}
          body={(user) => formatDate(user.dateCreation)}
          sortable
          showFilterMenu={false}
        />
        <Column
          field="blocked"
          header={`${localeText("blocked")}?`}
          body={(user) => {
            return (
              <>
                {!user.blocked ? (
                  <span
                    className="team-member-role text-0 p-1 border-round"
                    style={{ backgroundColor: "#eb4034" }}
                  >
                    {localeText("no").toUpperCase()}
                  </span>
                ) : (
                  <span
                    className="team-member-role text-0 p-1 border-round"
                    style={{ backgroundColor: "#46a748" }}
                  >
                    {localeText("yes").toUpperCase()}
                  </span>
                )}
              </>
            );
          }}
          sortable
        />
        <Column
          header={localeText("blockOrUnblockUser")}
          body={(user) => {
            return (
              <>
                {!user.blocked ? (
                  <Button
                    className="p-button-danger p-button-rounded"
                    label={localeText("block")}
                    icon="pi pi-lock"
                    onClick={() => {
                      setUsername(user.username);
                      setBlocking(true);
                      setBlockingUnblockingVisible(true);
                    }}
                  />
                ) : (
                  <Button
                    className="p-button-success p-button-rounded"
                    label={localeText("unblock")}
                    icon="pi pi-lock-open"
                    onClick={() => {
                      setUsername(user.username);
                      setBlocking(false);
                      setBlockingUnblockingVisible(true);
                    }}
                  />
                )}
              </>
            );
          }}
        />
      </DataTable>
    </div>
  );
};

export default ListUsers;
